import socket from '../components/System/Socket/socket.js';

const downloadProgramCostsSpreadsheet = (user) => {
  if (!socket.connected) socket.connect();
  let data = {
    user: user,
    environment: process.env.ENVIRONMENT
  };
  socket.emit('generateProgramCostsExcel', data);
};

const downloadProjectScoresSpreadsheet = (user) => {
  if (!socket.connected) socket.connect();
  let data = {
    user: user,
    environment: process.env.ENVIRONMENT
  };
  socket.emit('generateProgramScoresExcel', data);
};

const downloadUserInformationSpreadsheetFromUserManagement = (user, nameConventions) => {
  if (!socket.connected) socket.connect();
  let data = {
    user, 
    nameConventions,
    environment: process.env.ENVIRONMENT
  };
  socket.emit('generateUserInformationExcelFromUserManagement', data);
};

const downloadProgramInventorySpreadsheet = (user) => {
  if (!socket.connected) socket.connect();
  let data = {
    user: user,
    environment: process.env.ENVIRONMENT
  };
  socket.emit('generateProgramInventoryExcel', data);
};

const downloadProgramInsightsSpreadsheet = (user) => { 
  if (!socket.connected) socket.connect();
  let data = {
    user: user,
    environment: process.env.NODE_ENV
  };
  socket.emit('generateInsightsExcel', data);
};

const downloadSummaryReportExcel = (user) => {
  if (!socket.connected) socket.connect();
  let data = {
    user: user,
    environment: process.env.ENVIRONMENT
  };
  socket.emit('generateSummaryReportExcel', data);
};

const downloadBudgetRequestsSummarySpreadsheet = (user) => {
  if (!socket.connected) socket.connect();

  let data = {
    user: user,
    environment: process.env.ENVIRONMENT,
    budgetId: user?.activeBudget?.id
  };
  socket.emit('generateBudgetRequestsSummaryExcel', data);
};
const downloadBulkUploadScoresSpreadsheet = (user) => {
  if (!socket.connected) socket.connect();
  let data = {
    user: user,
    environment: process.env.ENVIRONMENT
  };
  socket.emit('generateBulkUploadScoresExcel', data);
};

const downloadBudgetAndInventorySpreadsheet = (user) => {
  if (!socket.connected) socket.connect();
  let data = {
    user: user,
    environment: process.env.ENVIRONMENT,
    budgetName: user.activeBudget.name,
    budgetId: user.activeBudget.id,
    budgetYear: user.activeBudget.year
  };
  socket.emit('generateBudgetAndInventoryExcel', data);
};

const createAndDownloadResultsPdf = (user) => {
  if (!socket.connected) socket.connect();
  let data = {
    user: user,
    environment: process.env.ENVIRONMENT
  };
  socket.emit('generateResultsPdf', data);
};

const createAndDownloadProgramPdf = (user) => {
  if (!socket.connected) socket.connect();
  let data = {
    user: user,
    environment: process.env.ENVIRONMENT
  };
  socket.emit('generateProgramsPdf', data);
};

const downloadAllocationsSpreadsheet = (user) => {
  if (!socket.connected) socket.connect();
  let data = {
    user: user,
    environment: process.env.ENVIRONMENT
  };
  socket.emit('generateAllocationsExcel', data);
};

const handleDownloadBudget = (budget, user) => {
  if (!socket.connected) socket.connect();
  let data = {
    user: user,
    environment: process.env.ENVIRONMENT,
    budgetName: budget.name,
    budgetYear: budget.year,
  };

  socket.emit('generateBudgetSummaryExcel', data);
  socket.emit('documentLoading', 'Budget summary', '.xlsx');
  socket.emit('documentLoading', 'personnel', '.csv');
  socket.emit('documentLoading', 'nonPersonnel', '.csv');
};

const handleDownloadBudgetUploadTemplate = (user) => {
  if (!socket.connected) socket.connect();

  const data = {
    user: user,
    environment: process.env.ENVIRONMENT
  };

  socket.emit('generateBudgetUploadTemplateExcel', data);
  socket.emit('documentLoading', 'Budget upload template', '.xlsx');
};

const downloadBangForTheBuckSpreadsheet = (user) => {
  if (!socket.connected) socket.connect();
  let data = {
    user: user,
    environment: process.env.ENVIRONMENT
  };

  socket.emit('generateBangForTheBuckExcel', data);
};

const downloadROIReportPdf = (user) => {
  if (!socket.connected) socket.connect();
  let data = {
    user: user,
    environment: process.env.ENVIRONMENT
  };
  socket.emit('generateROIReportPdf', data);
};

const downloadProgramProcessOverlapExcel = (analysisResponse, user) => {
  if (!socket.connected) socket.connect();
  let data = {
    user,
    environment: process.env.ENVIRONMENT,
    analysisResponse
  };
  socket.emit('generateProgramProcessOverlapExcel', data);
};

const downloadProgramProcessOverlapPDF = (overlapAnalysis, analysisResponse, introAndConclusion, user) => {
  if (!socket.connected) socket.connect();
  let data = {
    user,
    environment: process.env.ENVIRONMENT,
    overlapAnalysis,
    analysisResponse,
    introAndConclusion
  };
  socket.emit('generateProgramProcessOverlapPDF', data);
};

const downloadOverAllocationReport = (budget, user) => {
  if (!socket.connected) socket.connect();
  let data = {
    user,
    budget,
    environment: process.env.ENVIRONMENT,
  };
  socket.emit('generateOverAllocationReport', data);
};

export const emitBudgetUploadStatusReportChunk = (payload) => {
  if (!socket.connected) socket.connect();
  socket.emit('generateBudgetUploadStatusReport', payload);
};

export const emitDocumentLoading = (title, fileExtension) => {
  if (!socket.connected) socket.connect();
  socket.emit('documentLoading', title, fileExtension);
};

const downloadProgramInsightImplementationPlan = (implementationPlans, fileType, user) => {
  if (!socket.connected) socket.connect();
  let data = {
    implementationPlans,
    environment: process.env.ENVIRONMENT,
    user
  };
  if (fileType === 'pdf') {
    socket.emit('generateProgramInsightImplementationPlanPdf', data);
  } else {
    socket.emit('generateProgramInsightImplementationPlanExcel', data);
  }
};

export {
  downloadProgramCostsSpreadsheet,
  downloadProgramInsightsSpreadsheet,
  downloadProjectScoresSpreadsheet,
  downloadUserInformationSpreadsheetFromUserManagement,
  downloadProgramInventorySpreadsheet,
  downloadBudgetRequestsSummarySpreadsheet,
  downloadBudgetAndInventorySpreadsheet,
  downloadSummaryReportExcel,
  downloadBulkUploadScoresSpreadsheet,
  createAndDownloadResultsPdf,
  createAndDownloadProgramPdf,
  downloadAllocationsSpreadsheet,
  handleDownloadBudget,
  handleDownloadBudgetUploadTemplate,
  downloadBangForTheBuckSpreadsheet,
  downloadROIReportPdf,
  downloadProgramProcessOverlapExcel,
  downloadProgramProcessOverlapPDF,
  downloadOverAllocationReport,
  downloadProgramInsightImplementationPlan
};
